/**
 * @generated SignedSource<<67c4a61676a6940dc19deb497108d795>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type DeploymentState = "CANCELLED" | "FAILED" | "IN_PROGRESS" | "PENDING" | "ROLLED_BACK" | "SUCCESSFUL" | "UNKNOWN" | "%future added value";
export type DevOpsEnvironmentCategory = "DEVELOPMENT" | "PRODUCTION" | "STAGING" | "TESTING" | "UNMAPPED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type deploymentData_softwareReleasesVersionDetailIssueList$data = {
  readonly summarisedDeployments: {
    readonly deploymentEnvironment: {
      readonly category: DevOpsEnvironmentCategory | null | undefined;
    } | null | undefined;
    readonly deploymentState: DeploymentState | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"statusIcon_softwareReleasesVersionDetailIssueList">;
  } | null | undefined;
  readonly " $fragmentType": "deploymentData_softwareReleasesVersionDetailIssueList";
};
export type deploymentData_softwareReleasesVersionDetailIssueList$key = {
  readonly " $data"?: deploymentData_softwareReleasesVersionDetailIssueList$data;
  readonly " $fragmentSpreads": FragmentRefs<"deploymentData_softwareReleasesVersionDetailIssueList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "deploymentData_softwareReleasesVersionDetailIssueList",
  "selections": [
    {
      "concreteType": "DevOpsSummarisedDeployments",
      "kind": "LinkedField",
      "name": "summarisedDeployments",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "deploymentState"
        },
        {
          "concreteType": "DevOpsEnvironment",
          "kind": "LinkedField",
          "name": "deploymentEnvironment",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "category"
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "statusIcon_softwareReleasesVersionDetailIssueList"
        }
      ]
    }
  ],
  "type": "DevOpsSummarisedEntities"
};

(node as any).hash = "277da37647ab9525c90d0b7f19fa625e";

export default node;
